<template>
<v-container class="fill-height" fluid>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Login form</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert v-if="errorMessage.length" type="error">
              {{ errorMessage }}
            </v-alert>
            <v-alert v-if="successLogged" type="success">
              You have been successfully logged in.
            </v-alert>
            <v-form @submit.prevent="handleSubmit" id="login-form" v-model="valid">
              <v-text-field
                label="Email"
                v-model="email"
                name="email"
                prepend-icon="mdi-account"
                :rules="[rules.required, rules.email]"
                type="email"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                v-model="password"
                name="password"
                :rules="[rules.required]"
                prepend-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" type="submit" form="login-form">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    email: null,
    password: null,
    valid: true,
    errorMessage: '',
    successLogged: false,
    rules: {
      required: value => !!value || 'Това поле е задължително!',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        return pattern.test(value) || 'Невалиден имейл адрес'
      },
    }
  }),
  methods: {
    handleSubmit () {
      this.errorMessage = ''
      if (!this.valid) {
        return
      }

      this.$http.post('users/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        if (response.response) {
          const res = response.response
          if (!res.data.success) {
            sessionStorage.removeItem('accessToken')
            this.errorMessage = res.data.message
            return
          }
        }

        if (response.data.success) {
          sessionStorage.setItem('accessToken', response.data.data.token)
          this.successLogged = true

          setTimeout(() => this.$router.push('/'), 2000)
        }
      }).catch(error => {
        sessionStorage.removeItem('accessToken')
        this.errorMessage = error.response.data.message
      })
    }
  }
}
</script>